import React from "react";
import { Dialog as MUIDialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import type { FC } from "react";
import { useDialogStyles } from "./Dialog.styles";
import type { IDialogProps } from "./Dialog.types";

export const Dialog: FC<IDialogProps> = (props) => {
  const classes = useDialogStyles();
  const { open, onClose } = props;

  return (
    <MUIDialog
      open={open}
      classes={{ paper: classes.root }}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className={classes.header}>
        Bulk export is in progress
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" className={classes.text}>
          The file is being generated according to your request.
          <br />
          It will be sent via email and downloaded directly to your device at the same time.
          <br />
          The download link will be active for 7 days.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary" autoFocus className={classes.button}>
          Ok
        </Button>
      </DialogActions>
    </MUIDialog>
  );
};
